{
  "familyId": "SPR-HOOFDLETTER",
  "questions": [
    {
      "id": "SPR-HOOFDLETTER-001",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welk woord in deze zin moet een hoofdletter hebben?\n'Op zaterdag gaat emma naar de markt.'",
      "context": null,
      "options": [
        "zaterdag (dag van de week)",
        "emma (persoonsnaam)",
        "markt (gewoon zelfstandig naamwoord)",
        "gaat (werkwoord)"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Hoofdletterregels", "content": "Gebruik een hoofdletter bij: namen van personen (Emma, Jan), namen van plaatsen (Amsterdam, Nederland), begin van een zin. Dagen van de week krijgen in het Nederlands GEEN hoofdletter.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_naam",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Emma' is een persoonsnaam en moet met een hoofdletter. Dagen van de week (zaterdag) krijgen in het Nederlands geen hoofdletter. Gewone woorden (markt, gaat) krijgen ook geen hoofdletter. Regel: alleen namen van personen en plaatsen krijgen een hoofdletter (naast het eerste woord van een zin).",
        "solutionSteps": [
          "Stap 1: Zoek de namen → 'emma' is een persoonsnaam",
          "Stap 2: Persoonsnamen krijgen altijd een hoofdletter → Emma",
          "Stap 3: 'zaterdag' is een dag → geen hoofdletter in het Nederlands",
          "Stap 4: 'markt' en 'gaat' zijn gewone woorden → geen hoofdletter"
        ],
        "distractorExplanations": {
          "0": "Dagen van de week (zaterdag, maandag, dinsdag) krijgen in het Nederlands GEEN hoofdletter. Dit is anders dan in het Engels! De fout is dat je de Nederlandse regel verwart met de Engelse.",
          "1": "Correct! 'Emma' is een persoonsnaam en moet met een hoofdletter.",
          "2": "'Markt' is een gewoon zelfstandig naamwoord en krijgt geen hoofdletter. Alleen eigennamen (namen van personen en plaatsen) krijgen een hoofdletter.",
          "3": "Werkwoorden krijgen nooit een hoofdletter (tenzij ze aan het begin van een zin staan). 'Gaat' is een gewoon werkwoord."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.hoofdletter-dag", "label": "Denkt dat dagen een hoofdletter krijgen", "optionIndex": 0 },
          { "id": "spr.hoofdletter-znw", "label": "Denkt dat gewone zelfstandige naamwoorden een hoofdletter krijgen", "optionIndex": 2 },
          { "id": "spr.hoofdletter-ww", "label": "Denkt dat werkwoorden een hoofdletter krijgen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-HOOFDLETTER-002",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct geschreven?",
      "context": null,
      "options": [
        "de hond rent door het park.",
        "De hond rent door het park.",
        "De Hond rent door het park.",
        "De hond Rent door het park."
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Begin van een zin", "content": "Het eerste woord van een zin schrijf je altijd met een hoofdletter.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_zinsbegin",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het eerste woord van een zin schrijf je altijd met een hoofdletter. 'De' is het eerste woord, dus schrijf je 'De' met een hoofdletter D.",
        "solutionSteps": [
          "Stap 1: Het eerste woord van een zin krijgt een hoofdletter",
          "Stap 2: Controleer of er namen in de zin staan → nee",
          "Stap 3: Alleen 'De' (zinsbegin) krijgt een hoofdletter"
        ],
        "distractorExplanations": {
          "0": "Fout: 'de' begint met een kleine letter, maar het eerste woord van een zin moet een hoofdletter hebben: 'De hond...' De fout is een ontbrekende hoofdletter aan het zinsbegin.",
          "1": "Correct! 'De' begint met een hoofdletter omdat het het eerste woord van de zin is.",
          "2": "Fout: 'Hond' is geen naam en staat niet aan het begin van de zin. De fout is dat een gewoon zelfstandig naamwoord onterecht een hoofdletter heeft gekregen.",
          "3": "Fout: 'Rent' is een gewoon werkwoord in het midden van de zin. De fout is dat een werkwoord onterecht een hoofdletter heeft gekregen — alleen namen en het eerste woord krijgen een hoofdletter."
        }
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-HOOFDLETTER-003",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Hoeveel hoofdletters horen er in deze zin?\n'vorige week ging ik naar amsterdam met mijn oma.'",
      "context": null,
      "options": [
        "1 hoofdletter (alleen Amsterdam)",
        "2 hoofdletters (Vorige en Amsterdam)",
        "3 hoofdletters (Vorige, Amsterdam en Oma)",
        "0 hoofdletters (alles met kleine letter)"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Plaatsnamen", "content": "Namen van steden, landen en plaatsen schrijf je altijd met een hoofdletter: Amsterdam, Nederland, Europa. Het eerste woord van een zin krijgt ook een hoofdletter. Gewone woorden zoals 'oma' krijgen geen hoofdletter.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_plaatsnaam",
      "variantIndex": 3,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Er horen 2 hoofdletters in deze zin: 'Vorige' (begin van de zin) en 'Amsterdam' (plaatsnaam). Het woord 'oma' is geen eigennaam en krijgt dus geen hoofdletter. Regel: hoofdletter bij zinsbegin + eigennamen.",
        "solutionSteps": [
          "Stap 1: Eerste woord 'vorige' → hoofdletter (zinsbegin) → Vorige",
          "Stap 2: 'amsterdam' → hoofdletter (plaatsnaam) → Amsterdam",
          "Stap 3: 'oma' → geen hoofdletter (gewoon woord, geen naam)",
          "Totaal: 2 hoofdletters"
        ],
        "distractorExplanations": {
          "0": "Je vergat de hoofdletter aan het begin van de zin. 'Vorige' is het eerste woord en moet ook een hoofdletter hebben. Regel: het eerste woord van elke zin krijgt een hoofdletter.",
          "1": "Correct! 'Vorige' (zinsbegin) en 'Amsterdam' (plaatsnaam) krijgen een hoofdletter.",
          "2": "'Oma' is geen eigennaam — het is een familieaanduiding. Alleen als je 'oma' als naam gebruikt (bijv. 'Oma Jansen') krijgt het een hoofdletter. Hier is het een gewoon woord.",
          "3": "Elke zin begint met een hoofdletter, en eigennamen krijgen altijd een hoofdletter. Er zijn dus minstens 2 hoofdletters nodig."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.hoofdletter-zinsbegin-vergeten", "label": "Vergeet hoofdletter aan zinsbegin", "optionIndex": 0 },
          { "id": "spr.hoofdletter-familienaam", "label": "Denkt dat familieaanduidingen een hoofdletter krijgen", "optionIndex": 2 },
          { "id": "spr.hoofdletter-geen-nodig", "label": "Denkt dat geen hoofdletters nodig zijn", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-HOOFDLETTER-004",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welk woord krijgt hier ONTERECHT een hoofdletter?\n'Mijn Vriend Thomas woont in Rotterdam.'",
      "context": null,
      "options": [
        "Mijn (staat aan het begin van de zin)",
        "Vriend (gewoon zelfstandig naamwoord)",
        "Thomas (persoonsnaam)",
        "Rotterdam (plaatsnaam)"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Overzicht hoofdletterregels", "content": "Hoofdletter bij: 1) begin van een zin, 2) namen van personen, 3) namen van plaatsen. Gewone woorden zoals 'vriend' krijgen geen hoofdletter.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_combinatie",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Vriend' is een gewoon zelfstandig naamwoord en krijgt geen hoofdletter. Het moet 'vriend' zijn met een kleine letter. 'Mijn' (zinsbegin), 'Thomas' (persoonsnaam) en 'Rotterdam' (plaatsnaam) krijgen wél terecht een hoofdletter. Regel: alleen eigennamen en het eerste woord van een zin krijgen een hoofdletter.",
        "solutionSteps": [
          "Stap 1: 'Mijn' → zinsbegin → hoofdletter terecht ✓",
          "Stap 2: 'Vriend' → gewoon woord → hoofdletter ONTERECHT ✗",
          "Stap 3: 'Thomas' → persoonsnaam → hoofdletter terecht ✓",
          "Stap 4: 'Rotterdam' → plaatsnaam → hoofdletter terecht ✓"
        ],
        "distractorExplanations": {
          "0": "'Mijn' staat aan het begin van de zin en krijgt terecht een hoofdletter. Het eerste woord van elke zin begint met een hoofdletter.",
          "1": "Correct! 'Vriend' is een gewoon woord en krijgt geen hoofdletter. Het moet 'vriend' zijn.",
          "2": "'Thomas' is een persoonsnaam en krijgt terecht een hoofdletter. Persoonsnamen schrijf je altijd met een hoofdletter.",
          "3": "'Rotterdam' is een plaatsnaam en krijgt terecht een hoofdletter. Plaatsnamen schrijf je altijd met een hoofdletter."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.hoofdletter-zinsbegin-onterecht", "label": "Denkt dat zinsbegin-hoofdletter onterecht is", "optionIndex": 0 },
          { "id": "spr.hoofdletter-naam-onterecht", "label": "Denkt dat persoonsnaam-hoofdletter onterecht is", "optionIndex": 2 },
          { "id": "spr.hoofdletter-plaats-onterecht", "label": "Denkt dat plaatsnaam-hoofdletter onterecht is", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-HOOFDLETTER-005",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welke woorden hoeven GEEN hoofdletter in deze zin?\n'Op maandag gaat Lisa naar school in Nederland.'",
      "context": null,
      "options": ["maandag en school", "Lisa en Nederland", "maandag en Nederland", "alleen Lisa"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Wanneer geen hoofdletter?", "content": "Gewone zelfstandige naamwoorden (school, huis) en dagen van de week (maandag, dinsdag) krijgen in het Nederlands GEEN hoofdletter. Wel een hoofdletter bij: namen van personen (Lisa) en landen (Nederland).", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_geen",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "In het Nederlands schrijf je dagen van de week (maandag, dinsdag) en gewone zelfstandige naamwoorden (school, huis) met een kleine letter. Persoonsnamen (Lisa) en landnamen (Nederland) krijgen wél een hoofdletter.",
        "solutionSteps": [
          "'maandag' = dag van de week → kleine letter",
          "'school' = gewoon zelfstandig naamwoord → kleine letter",
          "'Lisa' = persoonsnaam → hoofdletter",
          "'Nederland' = landnaam → hoofdletter"
        ],
        "distractorExplanations": {
          "0": "Goed! In het Nederlands schrijf je dagen (maandag) en gewone woorden (school) met een kleine letter. Alleen namen van personen en plaatsen krijgen een hoofdletter.",
          "1": "Lisa is een persoonsnaam en Nederland is een landnaam — die krijgen juist wél een hoofdletter. De woorden zonder hoofdletter zijn 'maandag' en 'school'.",
          "2": "Bijna goed: 'maandag' hoeft inderdaad geen hoofdletter (dag van de week), maar 'Nederland' is een landnaam en krijgt wél een hoofdletter. De twee woorden zonder hoofdletter zijn 'maandag' en 'school'.",
          "3": "Lisa krijgt juist wél een hoofdletter (persoonsnaam). De woorden zonder hoofdletter zijn 'maandag' (dag van de week) en 'school' (gewoon woord)."
        }
      }
    },
    {
      "id": "SPR-HOOFDLETTER-006",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "error_spotting",
      "question": "Zoek de hoofdletterfouten in deze tekst en verbeter ze.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Op woensdag gaat jan met zijn moeder naar utrecht. Ze gaan naar het Museum en daarna eten ze een ijsje.",
        "errors": [
          {
            "word": "jan",
            "position": 3,
            "correction": "Jan",
            "explanation": "'Jan' is een persoonsnaam en moet met een hoofdletter."
          },
          {
            "word": "utrecht",
            "position": 8,
            "correction": "Utrecht",
            "explanation": "'Utrecht' is een plaatsnaam en moet met een hoofdletter."
          },
          {
            "word": "Museum",
            "position": 12,
            "correction": "museum",
            "explanation": "'Museum' is een gewoon zelfstandig naamwoord en krijgt geen hoofdletter (tenzij het een eigennaam is)."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hoofdletterregels", "content": "Hoofdletter bij: namen van personen (Jan), namen van plaatsen (Utrecht), begin van een zin. Geen hoofdletter bij: gewone woorden (museum, school, park).", "icon": "book" } }
      ],
      "conceptId": "hoofdletter_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Drie fouten: 'jan' moet 'Jan' zijn (persoonsnaam), 'utrecht' moet 'Utrecht' zijn (plaatsnaam), 'Museum' moet 'museum' zijn (gewoon woord, geen eigennaam). Correct: 'Op' (zinsbegin), 'Ze' (zinsbegin) ✓",
        "solutionSteps": [
          "Fout 1: jan → Jan (persoonsnaam → hoofdletter)",
          "Fout 2: utrecht → Utrecht (plaatsnaam → hoofdletter)",
          "Fout 3: Museum → museum (gewoon woord → kleine letter)",
          "Correct: 'Op' en 'Ze' (zinsbegin) ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-HOOFDLETTER-007",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "categorize",
      "question": "Sorteer deze woorden: welke krijgen een hoofdletter en welke niet?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Hoofdletter", "Kleine letter"],
        "items": [
          { "text": "Amsterdam", "correctCategory": 0 },
          { "text": "school", "correctCategory": 1 },
          { "text": "Emma", "correctCategory": 0 },
          { "text": "maandag", "correctCategory": 1 },
          { "text": "Nederland", "correctCategory": 0 },
          { "text": "fiets", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hoofdletter of niet?", "content": "Hoofdletter: namen van personen (Emma), plaatsen (Amsterdam) en landen (Nederland).\nKleine letter: gewone woorden (school, fiets) en dagen van de week (maandag).", "icon": "book" } }
      ],
      "conceptId": "hoofdletter_categorize",
      "variantIndex": 7,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Hoofdletter: Amsterdam (plaatsnaam), Emma (persoonsnaam), Nederland (landnaam). Kleine letter: school (gewoon woord), maandag (dag van de week), fiets (gewoon woord). In het Nederlands krijgen alleen eigennamen een hoofdletter.",
        "solutionSteps": [
          "Amsterdam → plaatsnaam → hoofdletter",
          "School → gewoon woord → kleine letter",
          "Emma → persoonsnaam → hoofdletter",
          "Maandag → dag van de week → kleine letter",
          "Nederland → landnaam → hoofdletter",
          "Fiets → gewoon woord → kleine letter"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-HOOFDLETTER-008",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "fill_in",
      "question": "Schrijf de naam van de stad correct over: 'We gaan op vakantie naar amsterdam.' Typ alleen de stadsnaam.",
      "correctAnswer": "Amsterdam",
      "data": {
        "acceptedAnswers": ["Amsterdam"],
        "caseSensitive": true,
        "placeholder": "typ de stadsnaam"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Plaatsnamen", "content": "Namen van steden schrijf je altijd met een hoofdletter: Amsterdam, Rotterdam, Utrecht.", "icon": "book" } }
      ],
      "conceptId": "hoofdletter_fill",
      "variantIndex": 8,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Amsterdam' is een plaatsnaam en schrijf je met een hoofdletter. Regel: namen van steden, landen en plaatsen krijgen altijd een hoofdletter.",
        "solutionSteps": [
          "Amsterdam is een plaatsnaam",
          "Plaatsnamen krijgen een hoofdletter",
          "Schrijf: Amsterdam (met hoofdletter A)"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-HOOFDLETTER-009",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "true_false_series",
      "question": "Beoordeel of elke bewering over hoofdletters klopt.",
      "data": {
        "statements": [
          { "text": "Persoonsnamen krijgen altijd een hoofdletter.", "isTrue": true },
          { "text": "Dagen van de week krijgen een hoofdletter.", "isTrue": false },
          { "text": "Het eerste woord van een zin krijgt een hoofdletter.", "isTrue": true },
          { "text": "Alle zelfstandige naamwoorden krijgen een hoofdletter.", "isTrue": false },
          { "text": "Namen van landen krijgen een hoofdletter.", "isTrue": true }
        ]
      },
      "correctAnswer": [true, false, true, false, true],
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hoofdletterregels", "content": "Hoofdletter bij: persoonsnamen, plaatsnamen, landnamen, zinsbegin. Geen hoofdletter bij: dagen, maanden, gewone zelfstandige naamwoorden.", "icon": "book" } }
      ],
      "conceptId": "hoofdletter_tf_series",
      "variantIndex": 9,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Persoonsnamen → hoofdletter ✓. Dagen → GEEN hoofdletter in het Nederlands ✗. Zinsbegin → hoofdletter ✓. Alle zelfstandige naamwoorden → NIET waar, alleen eigennamen ✗. Landnamen → hoofdletter ✓.",
        "solutionSteps": [
          "Persoonsnamen (Emma, Jan) → altijd hoofdletter ✓",
          "Dagen (maandag, dinsdag) → geen hoofdletter in NL ✗",
          "Zinsbegin → altijd hoofdletter ✓",
          "Alle znw → niet waar, alleen eigennamen ✗",
          "Landnamen (Nederland, België) → altijd hoofdletter ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-HOOFDLETTER-010",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "sentence_error_judge",
      "question": "Beoordeel elke zin: zijn de hoofdletters correct?",
      "data": {
        "sentences": [
          { "text": "Lisa woont in Rotterdam.", "hasError": false },
          { "text": "Op Maandag gaan we zwemmen.", "hasError": true, "correction": "Op maandag gaan we zwemmen.", "explanation": "'Maandag' is een dag van de week en krijgt in het Nederlands geen hoofdletter. Het moet 'maandag' zijn." },
          { "text": "Mijn broer heet Thomas.", "hasError": false },
          { "text": "We gaan naar Nederland op vakantie.", "hasError": false }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hoofdletterregels", "content": "Hoofdletter bij: namen (Lisa, Thomas, Rotterdam, Nederland), zinsbegin. Geen hoofdletter bij: dagen (maandag), gewone woorden.", "icon": "book" } }
      ],
      "conceptId": "hoofdletter_error_judge",
      "variantIndex": 10,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De fout zit in zin 2: 'Maandag' moet 'maandag' zijn. Dagen van de week krijgen in het Nederlands geen hoofdletter. De andere zinnen zijn correct: Lisa (persoonsnaam) ✓, Rotterdam (plaatsnaam) ✓, Thomas (persoonsnaam) ✓, Nederland (landnaam) ✓.",
        "solutionSteps": [
          "Zin 1: Lisa (naam) + Rotterdam (plaats) → correct ✓",
          "Zin 2: Maandag → dag van de week → geen hoofdletter → fout ✗",
          "Zin 3: Thomas (naam) → correct ✓",
          "Zin 4: Nederland (land) → correct ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-HOOFDLETTER-011",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "matching",
      "question": "Koppel elk woord aan de juiste regel: waarom wel of geen hoofdletter?",
      "data": {
        "pairs": [
          { "left": "Amsterdam", "right": "Hoofdletter: plaatsnaam" },
          { "left": "maandag", "right": "Kleine letter: dag van de week" },
          { "left": "Emma", "right": "Hoofdletter: persoonsnaam" },
          { "left": "school", "right": "Kleine letter: gewoon woord" }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hoofdletter of niet?", "content": "Hoofdletter: namen van personen (Emma), plaatsen (Amsterdam), landen (Nederland). Kleine letter: dagen (maandag), gewone woorden (school, fiets).", "icon": "book" } }
      ],
      "conceptId": "hoofdletter_matching",
      "variantIndex": 11,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Amsterdam → plaatsnaam → hoofdletter. Maandag → dag van de week → kleine letter. Emma → persoonsnaam → hoofdletter. School → gewoon woord → kleine letter. Regel: alleen eigennamen (personen, plaatsen, landen) krijgen een hoofdletter.",
        "solutionSteps": [
          "Amsterdam → plaatsnaam → hoofdletter ✓",
          "Maandag → dag → kleine letter ✓",
          "Emma → persoonsnaam → hoofdletter ✓",
          "School → gewoon woord → kleine letter ✓"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    }
  ]
}